import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTrashAlt, faPencilAlt, faTimes, faCheck} from '@fortawesome/free-solid-svg-icons';

const DatacentreIndex = ({dc, api, user, children}) => {

  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState(dc.name);

  const setNameValue = (evt) => setName(evt.target.value);
  const editDatacentre = () => setEditMode(true);
  const cancelEdits = () => {
    setName(dc.name);
    setEditMode(false);
  }
  const confirmEdits = (evt) => {
    evt.preventDefault();
    api.updateDatacentre(dc.id, dc.name, {name: name});
    setEditMode(false);
  }
  const deleteDatacentre = () => {
    let confirmed = window.confirm(`Delete Datacentre ${dc.id}: ${dc.name}?`)
    if(!confirmed) return;
    api.deleteDatacentre(dc.id, dc.name);
  }

  if(editMode) {
    return <div className="Datacentre col-md-4 col-sm-12">
    <div className="list-group">
      <form className="Datacentre-heading list-group-item" onSubmit={confirmEdits}>
        <input className="form-control" type="text" value={name} onChange={setNameValue} />
        <button type="button" onClick={cancelEdits} className="Outlet-menu btn btn-danger"><FontAwesomeIcon className={`Outlet-icon`} icon={faTimes} title="Cancel" /></button>
        <button type="submit" className="Outlet-menu btn btn-success"><FontAwesomeIcon className={`Outlet-icon`} icon={faCheck} title="Confirm" /></button>
      </form>
      {children}
      {user.accessLevel >= 2 && 
        <Link className="Cab list-group-item" to={`/datacentre/${dc.id}/cab/new`} >
          <span className="Cab-badge badge badge-primary">+</span>
          <span className="Cab-name">Add New Cabinet...</span>
        </Link>
      }
    </div>
  </div>
  }

  return <div className="Datacentre col-md-4 col-sm-12">
    <div className="list-group">
      <form className="Datacentre-heading list-group-item" onSubmit={confirmEdits}>
        <Link className="Datacentre-link" to={"/datacentre/" + dc.id}>{dc.name}</Link>
        {user.accessLevel >= 2 && 
          <button type="button" onClick={editDatacentre} className="Outlet-menu btn btn-secondary">
            <FontAwesomeIcon className={`Outlet-icon`} icon={faPencilAlt} title="Edit Cab" />
          </button>
        }
        {user.accessLevel >= 2 && 
          <button type="button" onClick={deleteDatacentre} className="Outlet-menu btn btn-danger">
            <FontAwesomeIcon className={`Outlet-icon`} icon={faTrashAlt} title="Delete" />
          </button>
        }
      </form>
      {children}
      {user.accessLevel >= 2 && 
        <Link className="Cab list-group-item" to={`/datacentre/${dc.id}/cab/new`} >
          <span className="Cab-badge badge badge-primary">+</span>
          <span className="Cab-name">Add New Cabinet...</span>
        </Link>
      }
    </div>
  </div>
}

export default DatacentreIndex;